import {Grid, Box, Typography, Card} from '@mui/material';
// import HeroPartnerSection from './HeroPartnerCompanies';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {ButtonV2} from '@jobseeker/lotus/elements';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {Image} from '@jobseeker/lotus/components/Image';
import {EPOCH_LEGAL_VERSION} from '@constants';

const RewardSection = () => {
  const scrollToTargetAdjusted = (elementId: string, offset: number = 0) => {
    const element = document.getElementById(elementId);
    if (!element) return;

    const headerOffset = offset;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: 'auto',
    });
  };

  const handleNavItemClick = (href: string) => {
    scrollToTargetAdjusted(href.slice(1), 100);
  };
  const theme = useWrappedTheme();

  const baseTypographyBoxStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 1.5,
  };

  const baseTypographyStyles = {
    fontSize: theme.typography.pxToRem(20),
    '@media (max-width: 1024px)': {
      fontSize: theme.typography.pxToRem(16),
    },
    '@media (max-width: 768px)': {
      fontSize: theme.typography.pxToRem(12),
    },
    fontWeight: 500,
    textAlign: 'center',
    color: '#000',
  };

  const specialTypographyStyles = {
    fontWeight: 'bold',
    color: 'primary.main',
  };
  const {competitionIdentity, testSlug} = useSelector(
    (state: AppState) => state.user?.profile
  );

  const {
    timelines: {
      version,
      config: {rewardsAndPrizes},
    },
  } = useSelector((state: AppState) => state.competition);
  const isLegal = version === EPOCH_LEGAL_VERSION;

  const registeredForCompetition = competitionIdentity && testSlug;
  return (
    <Card
      id="reward-section"
      sx={{
        width: '100%',
        margin: '0 auto',
        borderRadius: {xs: '0 0 30px 30px', md: '0 0 100px 100px'},
        paddingBottom: {xs: 5, md: 7},
        marginTop: !registeredForCompetition ? -9.5 : 0,
      }}
    >
      {/* <HeroPartnerSection /> */}
      <Box sx={{marginTop: 4, marginBottom: 3, textAlign: 'center'}}>
        <Typography
          variant="sectionMainHeading"
          sx={{
            fontSize: {
              xs: theme.typography.pxToRem(22),
              md: theme.typography.pxToRem(42),
            },
          }}
        >
          Rewards and Prizes
        </Typography>
      </Box>
      <Box
        sx={{
          margin: '0 auto',
          width: 255,
          height: 35,
          padding: 0,
          backgroundColor: 'secondary.dark',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Typography
          sx={{
            color: '#fff',
            textAlign: 'center',
            fontSize: {xs: 16, md: 18},
            fontWeight: 600,
          }}
        >
          {rewardsAndPrizes?.label}
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        justifyContent="center"
        sx={{
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'nowrap',
          justifyContent: {xs: 'flex-start', md: 'center'},
          overflow: 'auto',
          alignItems: 'stretch',
          marginLeft: 2,
        }}
      >
        {rewardsAndPrizes?.rewards?.map((reward, index) => (
          <Grid
            item
            xs={12}
            sm={12}
            key={reward?.id}
            sx={{
              paddingRight: 4,
              textAlign: 'center',
              paddingBottom: {xs: 5, md: 0},
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              '&:not(:last-child)::after': {
                content: '""',
                position: 'absolute',
                top: 65,
                right: 0,
                height: '60%',
                width: '2.5px',
                backgroundColor: '#eeeef9',
                transform: 'translateY(25%)',
                clear: 'both',
              },
            }}
          >
            <Box
              component={Image}
              src={reward?.image}
              alt={`Reward ${reward?.id}`}
              sx={{
                width: 'auto',
                height: 170,
                borderRadius: 1,
                margin: '0 auto',
              }}
            />
            {index === 2 ? (
              <>
                <Box sx={{...baseTypographyBoxStyles, mt: 2.5}}>
                  <Typography sx={baseTypographyStyles}>
                    {reward?.text1}
                  </Typography>
                  <Typography
                    sx={{
                      ...baseTypographyStyles,
                      marginLeft: 1,
                      marginRight: 1,
                    }}
                  >
                    -
                  </Typography>
                  <Typography
                    sx={{
                      ...baseTypographyStyles,
                      ...specialTypographyStyles,
                    }}
                  >
                    {reward?.text2}
                  </Typography>
                </Box>
                <Box sx={baseTypographyBoxStyles}>
                  <Typography sx={baseTypographyStyles}>
                    {reward?.text3}
                  </Typography>
                  <Typography
                    sx={{
                      ...baseTypographyStyles,
                      marginLeft: 1,
                      marginRight: 1,
                    }}
                  >
                    -
                  </Typography>
                  <Typography
                    sx={{
                      ...baseTypographyStyles,
                      ...specialTypographyStyles,
                    }}
                  >
                    {reward?.text4}
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                <Typography
                  sx={{
                    ...baseTypographyStyles,
                    marginTop: 2.5,
                  }}
                >
                  {reward?.text1}
                  <Typography
                    sx={{
                      ...baseTypographyStyles,
                      ...specialTypographyStyles,
                    }}
                  >
                    {reward?.text2}
                  </Typography>
                </Typography>
              </>
            )}
          </Grid>
        ))}
      </Grid>
      <Box
        onClick={() => handleNavItemClick('#partner-companies')}
        style={{color: 'primary.main'}}
      >
        <Typography
          sx={{
            marginTop: 6,
            fontSize: {
              xs: theme.typography.pxToRem(15),
              md: theme.typography.pxToRem(17),
            },
            fontWeight: 600,
            textAlign: 'center',
            paddingLeft: 3,
            paddingRight: 3,
          }}
        >
          All winners will be exclusively showcased to 50k + active recruiters
          on iimjobs.com
        </Typography>
      </Box>
      <Box
        sx={{
          textAlign: 'center',
          marginTop: 3,
        }}
      >
        {!isLegal && (
          <ButtonV2
            type="submit"
            sx={{
              height: {xs: '60px', md: '70px'},
              padding: 3,
              borderRadius: 9,
              background: 'primary.main',
              // mt: {xxs: 7, md: 1},
            }}
            href="/epoch/winners"
            target="_blank"
            variant="contained"
            size="large"
          >
            View last year winners
          </ButtonV2>
        )}
      </Box>
    </Card>
  );
};

export default RewardSection;
